import { useMemo } from 'react'
import { useRouter, useI18n } from '@popety_io/popety-io-lib'
import LegendSelector from '../../../../../components/LegendSelector'
import { getLegends } from './utils'

const EstimateCompanyContent = () => {
  const { query } = useRouter()
  const { t } = useI18n()

  const legends = getLegends(t)

  const mapLegends = useMemo(() => {
    return legends?.[query.companyLayer ?? 'total_employment'] || []
  }, [query.companyLayer])

  const options = [
    {
      value: 'total_employment',
      label: t('common.totalEmployment'),
    },
    {
      value: 'total_establishments',
      label: t('common.totalEstablishments'),
    },
    {
      value: 'total_employment_most_represented_sector',
      label: t('common.totalEmploymentMostRepresentedSector'),
    },
    {
      value: 'total_establishments_most_represented_sector',
      label: t('common.totalEstablishmentsMostRepresentedSector'),
    },
  ]

  return (
    <div>
      <LegendSelector
        options={options}
        legends={mapLegends}
        keyValue="companyLayer"
        legendValue="companyLegend"
        value="total_employment"
      />
    </div>
  )
}

export default EstimateCompanyContent
